// Translation: Utility > Feedback (Russian)
export default Object.freeze({
	hint: ''
})
